/* LK-MODAL2: two-step sheet. Step 2 length, step 3 designs. Pricing and picker logic untouched. */
(function(){
  function boot(){
    if(!(window.LKAB&&window.LKAB.variant==='b')) return; /* variant a = live page, untouched */
    var s2=document.getElementById('lk-step2'), s3=document.getElementById('lk-step3'),
        nxt=document.getElementById('lk-next'), back=document.getElementById('lk-back'),
        add=document.getElementById('lk-add2'), hd=document.getElementById('lk-mhd'),
        body=document.querySelector('.lk-modal-body'), opener=document.getElementById('lk-choose'),
        note=document.getElementById('lk-choosenote'), dz=document.getElementById('lk-designs'),
        hint=document.getElementById('lk-pickhint'), sprice=document.getElementById('lk-sprice');
    if(!s2||!s3||!nxt||!add) return;
    /* LK-V3d: double-tap guard. The step-1 and step-2 buttons share one spot on the screen, so an impatient
       second tap on "CHOOSE YOUR DESIGNS" used to land on "ADD TO CART" and add the 3 default designs by accident.
       - for 1s after a step change, taps on the footer do nothing (nobody adds to cart within 1s of seeing 12 designs)
       - for 0.6s after the sheet opens, taps anywhere on the sheet do nothing (a double tap on the opener or the
         sticky bar can no longer change the length or skip a step) */
    var blockFootUntil=0, blockSheetUntil=0, ft=document.querySelector('.lk-modal-ft'), sheet=document.querySelector('.lk-modal-sheet');
    if(sheet) sheet.addEventListener('click',function(e){
      var now=Date.now(), inFoot=!!(ft&&ft.contains(e.target));
      if(now<blockSheetUntil || (inFoot&&now<blockFootUntil)){ e.stopImmediatePropagation(); e.preventDefault(); }
    },true);
    /* after ADD TO CART the sheet closes at once and the sticky bar sits right under the finger: a second tap
       used to reopen the sheet behind the remover popup. For 2.5s after an add, the opener and sticky bar do nothing. */
    var blockOpenUntil=0;
    add.addEventListener('click',function(){ blockOpenUntil=Date.now()+2500; },true);
    if(opener) opener.addEventListener('click',function(e){ if(Date.now()<blockOpenUntil){ e.stopImmediatePropagation(); e.preventDefault(); } },true);
    function show(step){
      blockFootUntil=Date.now()+(step===3?1000:600);   /* 1s only in front of ADD TO CART; 0.6s in front of CHOOSE YOUR DESIGNS */
      var two=(step===2);
      s2.hidden=!two; s3.hidden=two;
      nxt.hidden=!two; add.style.display=two?'none':'';
      if(back) back.hidden=two;
      if(body) body.scrollTop=0;
      window.__lkStep=step;
    }
    nxt.addEventListener('click',function(){ show(3); });
    if(back) back.addEventListener('click',function(){ show(2); });
    if(opener) opener.addEventListener('click',function(){ blockSheetUntil=Date.now()+600; setTimeout(function(){ show(2); },10); });
    show(2);
    /* LK-V3f: B hid every kit price, so price-hunting NEW shoppers opened "Just the Glue" (the only prices on the page)
       and bought glue with no kit: 9 first-time glue-only orders on B vs 1 on A in 34h. The two-box selector is hidden in B
       (CSS) and replaced by one quiet line for customers who already own the kit. The glue panel itself is unchanged. */
    var rseg=document.getElementById('lk-seg'), pGlue=document.getElementById('lk-panel-glue'), guar=document.querySelector('#lk-form .lk-revguar');
    if(rseg&&pGlue){
      var tabBtn=function(t){ return rseg.querySelector('button[data-tab="'+t+'"]'); };
      var rlink=document.createElement('button'); rlink.type='button'; rlink.id='lk-refill-link'; rlink.className='lk-refill-link';
      rlink.innerHTML='Already have the kit? Get a glue refill &rarr;';
      var rnote=document.createElement('div'); rnote.className='lk-refill-note';
      rnote.innerHTML='<b>Refill only.</b> The glue works with the LoveSKN kit (nails + UV wand). <button type="button" id="lk-refill-back">&larr; Back to the nail kit</button>';
      pGlue.insertBefore(rnote,pGlue.firstChild);
      (guar&&guar.parentNode?guar.parentNode:pGlue.parentNode).insertBefore(rlink,guar?guar.nextSibling:null);
      rlink.addEventListener('click',function(){ var tb=tabBtn('glue'); if(tb) tb.click(); rlink.hidden=true; try{ pGlue.scrollIntoView({block:'start',behavior:'smooth'}); }catch(e){} });
      rnote.querySelector('#lk-refill-back').addEventListener('click',function(){ var tb=tabBtn('kit'); if(tb) tb.click(); rlink.hidden=false; try{ opener.scrollIntoView({block:'center',behavior:'smooth'}); }catch(e){} });
    }
    /* LK-V3c: the sticky bar used to scroll to the set chooser, which this version hides. Open the sheet instead. */
    var sadd=document.getElementById('lk-sadd');
    if(sadd&&opener) sadd.addEventListener('click',function(e){
      if(opener.offsetParent===null) return; /* glue tab: leave the original behaviour */
      e.stopImmediatePropagation(); e.preventDefault(); opener.click();
    },true);
    setInterval(function(){
      var len=window.__lkLen||'';
      if(note&&dz) note.textContent = dz.value ? (dz.value+(len?' · '+len:'')) : '';
      if(!hd) return;
      if(window.__lkStep===2){ hd.textContent='Choose your length'; return; }
      /* LK-V3: no price in the header. The count is progress, the price belongs on the button. */
      var n=0; try{ n=(dz&&dz.value)? dz.value.split(',').filter(function(s){return s.trim();}).length : 0; }catch(e){}
      hd.textContent = n ? (n+(n===1?' design chosen':' designs chosen')) : 'Choose your designs';
      return;
      var sets='',price='';
      if(hint){ var t=hint.textContent||''; var m=t.match(/(\d+)\s*sets?/i); if(m) sets=m[1]+(m[1]==='1'?' set':' sets');
                var p=t.match(/([$£€][\d.,]+)/); if(p) price=p[1]; }
      if(!price&&sprice) price=sprice.textContent||'';
      hd.textContent = sets ? (sets+(len?' · '+len:'')+(price?' · '+price:'')) : 'Choose your designs';
    },350);
  }
  if(document.readyState==='loading') document.addEventListener('DOMContentLoaded',boot); else boot();
})();
